import DateHelper from '@/lib/DateHelper'
import MatchHelper from '@/lib/MatchHelper'
import i18n from '@/lang/lang'
import _ from 'lodash'
const debug = require('debug')('OD::Lib:MatchProcessHelper')

const libLogs = false
const libLogsSimple = true

function getCurrentSetIndex(config, match, isMatchFinish) {
  let setIndex = 0
  match.sets.forEach((set, i) => {
    if (set.events && set.events.length > 0) {
      const setEnd = MatchHelper.matchSetEnd(config, set, i)
      setIndex = i
      if (setEnd && !isMatchFinish) {
        setIndex += 1
      }
    }
  })
  return setIndex
}

function generateDownTimeArray(set, team, maxNumDowntimesBySet) {
  return generateArray(set, team, 'downtime', maxNumDowntimesBySet)
}

function generateArray(set, team, action, numMax) {
  const array = []
  if (set && set.events) {
    const num = set.events.filter(event => event.action === action && event.team === team).length
    for (let index = 0; index < numMax; index++) {
      array.push(index < num ? 1 : 0)
    }
  }
  return array
}

function getCounters(config, set) {
  if (libLogs) debug('getCounters', { config, set })
  let counters = { l: {}, v: {} }
  if (set) {
    switch (config.type) {
      case 'pointBase':
        counters = generateTimeObject(config, set)
        break
      case 'timeBase':
        counters = generateTimeObject(config, set)
        break
      case 'baseballBase':
        counters = generateBaseballCountersObject(config, set)
        break
    }
  }
  return counters
}

function generateTimeObject(config, set) {
  if (libLogs) debug('generateTimeCountersObject', config, set)

  let displayDowntimes = config.numDownTimesPerGroupPeriod || config.downtimeBySet || false
  const displayFaults = config.maxFaultsBySet || false
  const displayChanges = config.numChangesBySet || false

  if (config.hideDowntimes) displayDowntimes = false

  const maxDowntimes = config.numDownTimesPerGroupPeriod || config.downtimeBySet || 0
  const maxFaults = config.maxFaultsBySet || 0
  const maxChanges = config.numChangesBySet || 0

  const data = { l: {}, v: {} }

  if (displayDowntimes) {
    const color = 'brown'
    data.l.downtime = { color, data: new Array(maxDowntimes).fill(0) }
    data.v.downtime = { color, data: new Array(maxDowntimes).fill(0) }
  }
  if (displayFaults) {
    const color = 'red'
    data.l.fault = { color, data: new Array(maxFaults).fill(0) }
    data.v.fault = { color, data: new Array(maxFaults).fill(0) }
  }
  if (displayChanges) {
    const color = 'blue'
    data.l.change = { color, data: new Array(maxChanges).fill(0) }
    data.v.change = { color, data: new Array(maxChanges).fill(0) }
  }

  if (set.events) {
    set.events.forEach((event, i) => {
      switch (event.action) {
        case 'downtime':
          if (displayDowntimes) {
            const item = data[event.team][event.action].data
            item[item.findIndex(i => i === 0)] = 1
          }
          break
        case 'fault':
          if (displayFaults) {
            const item = data[event.team][event.action].data
            item[item.findIndex(i => i === 0)] = 1
          }
          break
        case 'change':
          if (displayChanges) {
            const item = data[event.team][event.action].data
            item[item.findIndex(i => i === 0)] = 1
          }
          break
      }
    })
  }
  return data
}

function generateBaseballCountersObject(config, set) {
  // if (libLogs) debug('generateBaseballCountersObject', config, set)

  const maxStrikes = 3
  const maxBalls = 4
  const maxOuts = 3

  const data = {
    l: {
      strike: { color: 'orange', data: new Array(maxStrikes).fill(0) },
      ball: { color: 'blue', data: new Array(maxBalls).fill(0) },
      out: { color: 'red', data: new Array(maxOuts).fill(0) },
    },
    v: {
      strike: { color: 'orange', data: new Array(maxStrikes).fill(0) },
      ball: { color: 'blue', data: new Array(maxBalls).fill(0) },
      out: { color: 'red', data: new Array(maxOuts).fill(0) },
    },
  }
  if (set.events) {
    set.events.forEach((event, i) => {
      let item = null
      switch (event.action) {
        case 'strike':
          item = data[event.team][event.action].data
          item[item.findIndex(i => i === 0)] = 1
          if (item.filter(a => a === 1).length >= maxStrikes) {
            data[event.team][event.action].data = new Array(maxStrikes).fill(0)
          }
          break
        case 'ball':
          item = data[event.team][event.action].data
          item[item.findIndex(i => i === 0)] = 1
          if (item.filter(a => a === 1).length >= maxBalls) {
            data[event.team][event.action].data = new Array(maxBalls).fill(0)
          }
          break
        case 'out':
          item = data[event.team][event.action].data
          item[item.findIndex(i => i === 0)] = 1
          data[event.team].strike.data = new Array(maxStrikes).fill(0)
          data[event.team].ball.data = new Array(maxBalls).fill(0)
          break
        case '3outs':
          data[event.team].strike.data = new Array(maxStrikes).fill(0)
          data[event.team].ball.data = new Array(maxBalls).fill(0)
          data[event.team].out.data = new Array(maxOuts).fill(1)
          break
      }
    })
  }
  return data
}
function getSearch(club, match, searchArray, itemField, findField, blankDefault) {
  const item = club.search[searchArray].find(item => {
    const id = typeof item === 'object' ? item.id : item
    return match[itemField] === id
  })
  return item
    ? typeof item === 'object'
      ? item[findField]
      : blankDefault
      ? ''
      : item
    : blankDefault
    ? ''
    : match[itemField]
}

function getSetText(sport) {
  if (sport) {
    switch (sport.type) {
      case 'pointBase':
        return i18n.t('page.match.set')
      case 'timeBase':
        return i18n.t('page.match.period')
      case 'baseballBase':
        return i18n.t('page.match.inning')
    }
  }
  return ''
}
function getSetTextPlural(sport) {
  if (sport) {
    switch (sport.type) {
      case 'pointBase':
        return i18n.t('page.match.sets')
      case 'timeBase':
        return i18n.t('page.match.periods')
      case 'baseballBase':
        return i18n.t('page.match.innings')
    }
  }
  return ''
}

function isLastPointMine(config, set, team, i) {
  if (set) {
    const matchSetEnd = MatchHelper.matchSetEnd(config, set, i)
    if (!matchSetEnd) {
      if (set.events) {
        const points = set.events.filter(event => event.num > 0)
        if (points.length > 0) {
          const point = points[points.length - 1]
          let teamAux = point.team
          if (point.opposite) {
            teamAux = teamAux === 'l' ? 'v' : 'l'
          }
          if (teamAux === team) {
            return true
          }
        }
      }
    }
  }
  return false
}

function isDisabled(config, match, control, i, action, team, matchFinished) {
  const isDisabled = MatchHelper.isButtonDisabled(
    control,
    config,
    match,
    i,
    action,
    team,
    matchFinished
  )
  return isDisabled
}

function getLastUpdatedBy(match) {
  let name = ''
  const updateBy = match.lastEventSendBy
    ? match.lastEventSendBy
    : match.lastScoreUpdatedBy
    ? match.lastScoreUpdatedBy
    : ''

  updateBy.split(' ').forEach(word => {
    name += _.capitalize(word) + ' '
  })
  return name.trim()
}

function getBoardDataMode(match) {
  let mode = null
  match.sets.forEach(set => {
    if (set.events && set.events.length > 0) {
      set.events.forEach(event => {
        if (event.num > 0) {
          if (event.code && event.code.indexOf('_point') < 0) {
            if (event.player && !['?', '-'].includes(event.player.num)) {
              mode = 'pro'
            } else {
              if (!mode || mode !== 'pro') {
                mode = 'advanced'
              }
            }
          }
        }
      })
      if (!mode) {
        mode = 'basic'
      }
    }
  })
  return mode
}

function getPointControls(mode, pointBasicControls, pointControls) {
  return mode === 'basic' ? pointBasicControls : pointControls
}

function getSetsTableData(match, mode, pointBasicControls, pointControls, actionControls) {
  const subColumns = []
  const rowsL = []
  const rowsV = []
  const playersStats = {
    withValues: false,
    total: {
      l: {},
      v: {},
    },
    sets: [],
  }
  const basePointControls = getPointControls(mode, pointBasicControls, pointControls)

  if (mode !== 'basic') {
    basePointControls.slice().forEach(control => {
      if (!control.eventHide) {
        subColumns.push(control)
      }
    })
  }
  actionControls.slice().forEach(control => {
    if (!control.eventHide) {
      subColumns.push(control)
    }
  })
  match.sets.forEach(set => {
    const dataL = { score: 0 }
    const dataV = { score: 0 }
    const playersSetStats = {
      l: {},
      v: {},
    }
    subColumns.forEach(control => {
      dataL[control.code] = 0
      dataV[control.code] = 0
    })
    if (set.events) {
      set.events.forEach(event => {
        if (event.team === 'l') {
          if (event.code in dataL) {
            dataL[event.code] += 1
          }
          if (event.num > 0) {
            if (event.opposite) {
              dataV.score += event.num
            } else {
              dataL.score += event.num
            }
          }
        } else {
          if (event.code in dataV) {
            dataV[event.code] += 1
          }
          if (event.num > 0) {
            if (event.opposite) {
              dataL.score += event.num
            } else {
              dataV.score += event.num
            }
          }
        }
        // Player Stats
        if (event.player && !['-'].includes(event.player.num)) {
          if (event.player.num !== '?') {
            playersStats.withValues = true
          }
          if (event.team) {
            let stats = playersSetStats[event.team][event.player.num]
            if (!stats) {
              stats = {
                positives: 0,
                negatives: 0,
                events: {},
              }
            }
            if (Object.keys(stats.events).length === 0) {
              basePointControls.slice().forEach(control => {
                stats.events[control.code] = 0
              })
            }
            if (event.code in stats.events) {
              stats.events[event.code] += 1
              if (event.num > 0) {
                if (event.opposite) {
                  stats.negatives += 1
                } else {
                  stats.positives += 1
                }
              }
            }
            playersSetStats[event.team][event.player.num] = stats
          }
        }
      })
    }
    rowsL.push(dataL)
    rowsV.push(dataV)

    Object.keys(playersSetStats).forEach(teamKey => {
      const team = playersSetStats[teamKey]
      Object.keys(team).forEach(playerKey => {
        const player = team[playerKey]
        if (!playersStats.total[teamKey][playerKey]) {
          playersStats.total[teamKey][playerKey] = {}
        }
        Object.keys(player).forEach(statKey => {
          const stat = player[statKey]
          if (typeof stat === 'object') {
            Object.keys(stat).forEach(eventStatKey => {
              const eventStat = stat[eventStatKey]
              if (!playersStats.total[teamKey][playerKey][statKey]) {
                playersStats.total[teamKey][playerKey][statKey] = {}
              }
              if (!playersStats.total[teamKey][playerKey][statKey][eventStatKey]) {
                playersStats.total[teamKey][playerKey][statKey][eventStatKey] = 0
              }
              playersStats.total[teamKey][playerKey][statKey][eventStatKey] += eventStat
            })
          } else {
            if (!playersStats.total[teamKey][playerKey][statKey]) {
              playersStats.total[teamKey][playerKey][statKey] = 0
            }
            playersStats.total[teamKey][playerKey][statKey] += stat
          }
        })
      })
    })
    playersStats.sets.push(playersSetStats)
  })

  // Generate aggregate stats

  const rowTotL = {}
  const rowTotV = {}
  rowsL.forEach(row => {
    Object.keys(row).forEach(key => {
      if (!rowTotL[key]) {
        rowTotL[key] = 0
      }
      rowTotL[key] += row[key]
    })
  })
  rowsV.forEach(row => {
    Object.keys(row).forEach(key => {
      if (!rowTotV[key]) {
        rowTotV[key] = 0
      }
      rowTotV[key] += row[key]
    })
  })

  return { subColumns, rowsL, rowsV, playersStats, rowTotL, rowTotV }
}

function acronym(text) {
  const matches = text.match(/\b(\w)/g)
  if (!matches) return ''
  return matches.join('')
}

function getInterval(performances) {
  const time = performances[performances.length - 1] - performances[performances.length - 2]
  return Math.round(time, 2) + ' m.'
}
function getAllInterval(performances) {
  const time = performances[performances.length - 1] - performances[0]
  return Math.round(time, 2) + ' m.'
}

function getSetResults(match, config) {
  const sets = []
  let resL = 0
  let resV = 0
  match.sets.forEach(set => {
    const events = []
    if (set.events) {
      if (config.type === 'pointBase') {
        resL = 0
        resV = 0
      }
      set.events.forEach(event => {
        if (event.num > 0) {
          if (event.team === 'l') {
            resL += event.opposite ? 0 : event.num
            resV += event.opposite ? event.num : 0
          } else {
            resV += event.opposite ? 0 : event.num
            resL += event.opposite ? event.num : 0
          }
        }
        events.push(Object.assign(event, { l: resL, v: resV }))
      })
    }
    sets.push(Object.assign({}, set, { events }))
  })
  return sets
}

export default {
  process({ club, sport, match }) {
    if (libLogs || libLogsSimple) debug('process', { club, sport, match })
    const performances = []
    if (libLogs || libLogsSimple) performances.push(performance.now())

    const config = MatchHelper.config(sport)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-001', getInterval(performances), { config })

    const result = MatchHelper.getMatchResult(config, match)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-002.1', getInterval(performances), { result })

    const finished = MatchHelper.isMatchFinish(config, match, result)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-002.2', getInterval(performances), { finished })

    const online = MatchHelper.isMatchOnline(config, match, finished)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-002.3', getInterval(performances), { online })

    const started = MatchHelper.isMatchStarted(config, match)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-003', getInterval(performances), { started })

    const maxNumDowntimesBySet = MatchHelper.getMaxNumDowntimesBySet(config)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-005', getInterval(performances), { maxNumDowntimesBySet })

    const setIndex = getCurrentSetIndex(config, match, finished)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-006', getInterval(performances), { setIndex })

    const currentSet = match.sets[setIndex]
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-007', getInterval(performances), { currentSet })

    const downTimesLocal = generateDownTimeArray(currentSet, 'l', maxNumDowntimesBySet)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-008', getInterval(performances), { downTimesLocal })

    const downTimesVisitor = generateDownTimeArray(currentSet, 'v', maxNumDowntimesBySet)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-009', getInterval(performances), { downTimesVisitor })

    const counters = getCounters(config, currentSet)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-010', getInterval(performances), { counters })

    const setText = getSetText(sport)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-011', getInterval(performances), { setText })

    const setTextPlural = getSetTextPlural(sport)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-012', getInterval(performances), { setTextPlural })

    const date = DateHelper.getDateTextString(`${match.date} ${match.hour}`)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-013', getInterval(performances), { date })

    const category = getSearch(club, match, 'categories', 'category', 'text', false)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-014', getInterval(performances), { category })

    const localTeam = getSearch(club, match, 'teams', 'localTeam', 'text', false)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-015', getInterval(performances), { localTeam })

    const localTeamLogo = getSearch(club, match, 'teams', 'localTeam', 'logo', true)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-016', getInterval(performances), { localTeamLogo })

    const visitorTeam = getSearch(club, match, 'teams', 'visitorTeam', 'text', false)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-017', getInterval(performances), { visitorTeam })

    const visitorTeamLogo = getSearch(club, match, 'teams', 'visitorTeam', 'logo', true)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-018', getInterval(performances), { visitorTeamLogo })

    const location = getSearch(club, match, 'locations', 'location', 'text', false)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-019', getInterval(performances), { location })

    const mapLink = getSearch(club, match, 'locations', 'location', 'mapLink', true)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-020', getInterval(performances), { mapLink })

    const lastPointLocal = isLastPointMine(config, currentSet, 'l', setIndex)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-021', getInterval(performances), { lastPointLocal })

    const lastPointVisitor = isLastPointMine(config, currentSet, 'v', setIndex)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-022', getInterval(performances), { lastPointVisitor })

    const setLocalPlayer =
      match.sets[setIndex] && match.sets[setIndex].players ? match.sets[setIndex].players.l : []
    if (libLogs) debug('process-023 -XXXXX')
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-023', getInterval(performances), { setLocalPlayer })

    const setVisitorPlayer =
      match.sets[setIndex] && match.sets[setIndex].players ? match.sets[setIndex].players.v : []
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-024', getInterval(performances), { setVisitorPlayer })

    const globalControls = config.globalControls.map(control => {
      control.disabled = isDisabled(config, match, control, setIndex, control.action, '', finished)
      return control
    })
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-025', getInterval(performances), { globalControls })

    const pointControls = config.pointControls.map(control => {
      control.disabled = {
        l: isDisabled(config, match, control, setIndex, control.action, 'l', finished),
        v: isDisabled(config, match, control, setIndex, control.action, 'v', finished),
      }
      return control
    })
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-026', getInterval(performances), { pointControls })

    const pointBasicControls = config.pointBasicControls.map(control => {
      control.disabled = {
        l: isDisabled(config, match, control, setIndex, control.action, 'l', finished),
        v: isDisabled(config, match, control, setIndex, control.action, 'v', finished),
      }
      return control
    })
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-027', getInterval(performances), { pointBasicControls })

    let actionControls = []
    if (match.sets[setIndex]) {
      actionControls = config.actionControls.map(control => {
        control.disabled = {
          l: isDisabled(config, match, control, setIndex, control.action, 'l', finished),
          v: isDisabled(config, match, control, setIndex, control.action, 'v', finished),
        }
        return control
      })
    }
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-028', getInterval(performances), { actionControls })
    let actionBasicControls = []
    if (match.sets[setIndex]) {
      actionBasicControls = config.actionBasicControls.map(control => {
        control.disabled = {
          l: isDisabled(config, match, control, setIndex, control.action, 'l', finished),
          v: isDisabled(config, match, control, setIndex, control.action, 'v', finished),
        }
        return control
      })
    }
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-029', getInterval(performances), { actionBasicControls })

    const timeControls = config.timeControls.map(control => {
      control.disabled = {
        l: isDisabled(config, match, control, setIndex, control.action, 'l', finished),
        v: isDisabled(config, match, control, setIndex, control.action, 'v', finished),
      }
      return control
    })
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-030', getInterval(performances), { timeControls })

    const lastUpdatedBy = getLastUpdatedBy(match)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-031', getInterval(performances), { lastUpdatedBy })

    const boardDataMode = getBoardDataMode(match)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-032', getInterval(performances), { boardDataMode })

    const setsTableData = getSetsTableData(
      match,
      boardDataMode,
      pointBasicControls,
      pointControls,
      actionControls
    )
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-033', getInterval(performances), { setsTableData })

    const basePointControls = getPointControls(boardDataMode, pointBasicControls, pointControls)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-034', getInterval(performances), { basePointControls })

    const localTeamAcronym = acronym(localTeam)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-035', getInterval(performances), { localTeamAcronym })

    const visitorTeamAcronym = acronym(visitorTeam)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-036', getInterval(performances), { visitorTeamAcronym })

    const sets = getSetResults(match, config)
    if (libLogs) performances.push(performance.now())
    if (libLogs) debug('process-037', getInterval(performances), { sets })

    if (libLogs) debug('PRE process-END')
    // TODO review generateBaseballCountersObject
    try {
      const matchObj = {
        id: match.id,
        club: Object.assign({}, club),
        sport,
        day: match.day,
        config,
        setText,
        setTextPlural,
        result,
        winnerLocal: result.l === config.numSetsToWin,
        winnerVisitor: result.v === config.numSetsToWin,
        started,
        isLive: online,
        finished: finished,
        date,
        category,
        localTeam,
        localTeamAcronym,
        localTeamLogo: localTeamLogo || '',
        visitorTeam,
        visitorTeamAcronym,
        visitorTeamLogo: visitorTeamLogo || '',
        location,
        mapLink,
        downTimesLocal,
        downTimesVisitor,
        counters,
        isFinish: finished,
        isBlocked: match.blocked || false,
        totalScoreLocal: result.l,
        totalScoreVisitor: result.v,
        setScoreLocal: currentSet ? currentSet.l : 0,
        setScoreVisitor: currentSet ? currentSet.v : 0,
        setNumber: setIndex + 1,
        setIndex,
        maxNumSets: match.sets.length,
        sets: sets,
        type: config.type,
        maxPlayerNum: config.maxPlayerNum,
        numPlayerInSet: config.numPlayerInSet,
        numExtraPlayerInSet: config.numExtraPlayerInSet,
        maxFaultsBySet: config.maxFaultsBySet,
        lastPointLocal,
        lastPointVisitor,
        setLocalPlayer: setLocalPlayer ? setLocalPlayer.slice() : [],
        setVisitorPlayer: setVisitorPlayer ? setVisitorPlayer.slice() : [],
        globalControls,
        pointControls,
        pointBasicControls,
        actionControls,
        actionBasicControls,
        basePointControls,
        timeControls,
        lastUpdatedBy,
        boardDataMode,
        comments: match.comments ? match.comments.slice() : null,
        setsTableData,
      }
      if (libLogs || libLogsSimple) performances.push(performance.now())
      if (libLogs || libLogsSimple)
        debug('process-END', getInterval(performances), getAllInterval(performances), { matchObj })
      return matchObj
    } catch (err) {
      debug('process-ERROR', err)
      throw err
    }
  },
}
